import {
  createApi,
  fakeBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react'

export const microserviceApi = createApi({
  baseQuery: fakeBaseQuery<FetchBaseQueryError>(),
  endpoints: () => ({}),
})
